import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🖼️", key: "frameIt" },
  { emoji: "📱", key: "shareOnline" },
  { emoji: "🎁", key: "giftIt" },
  { emoji: "💖", key: "keepForever" },
]

export default function PetsTopPriorityPage() {
  return (
    <RadioCardListPage translationKey="petsTopPriority" options={OPTIONS} />
  )
}
